import { BOT_MODE } from 'consts/enum';
import { createEngtChatHooks, syncMessagesAcrossTabs } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';
import { setSession } from 'js/session';
import { init } from '../../index';
import { appendPreviousMessages } from '../../js/conversation';
import { AppComponent } from './app.component';

export class App {
	constructor() {
		this.init();
	}

	async init() {
		await init(BOT_MODE.WIDGET);
		await this.initComponents();
		appendPreviousMessages();
		setSession();
		this.afterWidgetDOMLoad();
		this.injectEngagementTriggersTracker();
	}

	injectEngagementTriggersTracker() {
		if (
			ENGT_CHAT.get('config.activity_tracking_config.enabled') === true ||
			ENGT_CHAT.get('config.engagement_triggers_config.enabled') === true
		) {
			const trackingScript = document.createElement('script');
			trackingScript.src = `${ENGT_CHAT.get('config.brandedServer')}/tracker/static/tracker.js`;
			trackingScript.type = 'text/javascript';
			document.body.appendChild(trackingScript);
		}
	}

	afterWidgetDOMLoad() {
		ENGT_CHAT.get('reRenderLaunchScreen')();
		window.addEventListener('storage', syncMessagesAcrossTabs);
		window.onENGTWidgetLoad?.();
		createEngtChatHooks();
	}

	async initComponents() {
		return AppComponent.init();
	}
}
